module.exports = __webpack_public_path__ + "static/media/bundles_icon.4cd01a3f.svg";